import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export const useNavigationBlock = (blockNavigation: boolean, warningMessage: string) => {
  const history = useHistory();

  useEffect(() => {
    const unblock = history.block(() => {
      if (blockNavigation) {
        return warningMessage;
      }
    });

    return () => {
      unblock();
    };
  }, [blockNavigation, history, warningMessage]);
};
